import {
    GET_LIST_CUSTOMER_SCHEDULE,
    GET_LIST_CUSTOMER_SCHEDULE2,
    GET_LIST_CUSTOMER_SCHEDULE3,
    GET_SCHEDULE_LIST_BY_CUSTOMER,
    UPDATE_SPECIFIC_CUSTOMER_SCHEDULE,
    CREATE_NEW_CUSTOMER_SCHEDULE,
    REMOVE_CUSTOMER_SCHEDULE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0, // total records
            perPage: 50
        },
    },
    list2: {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0, // total records
            perPage: 20
        }
    },
    list3: {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0, // total records
            perPage: 20
        }
    },
    statistics: {},
    schedulesByCustomer: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        // case GET_LIST_CUSTOMER_SCHEDULE: {
        //     return {
        //         ...state,
        //         schedule_list: action.payload?.data || [],
        //         pagination: {
        //             currentPage: parseInt(action.payload.current_page),
        //             total: parseInt(action.payload.total),
        //             perPage: parseInt(action.payload.per_page),
        //         }
        //     }
        // }

        case GET_LIST_CUSTOMER_SCHEDULE: {
            return {
                ...state,
                list: {
                    data: action.payload?.list.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.list?.current_page),
                        total: parseInt(action.payload.list?.total),
                        perPage: parseInt(action.payload?.list.per_page),
                    }
                },
                statistics: action.payload?.statistics || {}
            }
        }

        case GET_LIST_CUSTOMER_SCHEDULE2: {
            return {
                ...state,
                list2: {
                    data: action.payload?.list.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.list?.current_page),
                        total: parseInt(action.payload.list?.total),
                        perPage: parseInt(action.payload?.list.per_page),
                    }
                },
                statistics: action.payload?.statistics || {}
            }
        }

        case GET_LIST_CUSTOMER_SCHEDULE3: {
            return {
                ...state,
                list3: {
                    data: action.payload?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload?.current_page),
                        total: parseInt(action.payload?.total),
                        perPage: parseInt(action.payload?.per_page),
                    }
                },
                statistics: action.payload?.statistics || {}
            }
        }

        case GET_SCHEDULE_LIST_BY_CUSTOMER: {
            const payload = action.payload || {}

            return {
                ...state,
                schedulesByCustomer: payload || []
            }
        }


        // case CREATE_NEW_CUSTOMER_SCHEDULE: {
        //     return {
        //         ...state,
        //         schedule_list: [action.payload, ...state.schedule_list],
        //         total: state.total + 1
        //     }
        // }
        // case UPDATE_SPECIFIC_CUSTOMER_SCHEDULE: {
        //     let index = state.schedule_list.findIndex((item) => {
        //         return item.id == action.payload.id;
        //     });
        //     let temp = [...state.schedule_list];
        //     temp[index] = action.payload;
        //     return { ...state, schedule_list: temp }
        // }
        // case REMOVE_CUSTOMER_SCHEDULE: {
        //     let temp = state.schedule_list.filter(item => {
        //         //console.log(action.payload)
        //         return action.payload.indexOf(item.id) < 0;
        //     });
        //     return { ...state, schedule_list: temp }
        // }
        default: return { ...state };
    }
}
